import { AdditionalMeta, PaginationAttribute } from 'bernie-http';

const CHINA_POS_SITE_ID = 100001;

export const getSeoData = context => {
  const additionalMeta: AdditionalMeta[] = [new PaginationAttribute('preconnect', 'https://images.trvl-media.com/')];

  context?.site?.id !== CHINA_POS_SITE_ID && additionalMeta.push(new PaginationAttribute('preconnect', 'https://maps.googleapis.com/'));

  return {
    seo: {
      additionalMeta,
      // Use blacksmith to add a reference to dateless version of pdp
      ...(context?.seoData && { canonical: context?.seoData.url }),
    },
  };
};
